import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vip-container" }
const _hoisted_2 = { class: "vip-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "header-text" }
const _hoisted_5 = { class: "subContainer" }
const _hoisted_6 = { class: "middle-banner" }
const _hoisted_7 = { class: "middle-header-text" }
const _hoisted_8 = { class: "middle-amount" }
const _hoisted_9 = { class: "bottomData-text" }
const _hoisted_10 = { class: "progressCard" }
const _hoisted_11 = {
  class: "card-top",
  style: {"color":"#FFE0CE"}
}
const _hoisted_12 = { class: "bar" }
const _hoisted_13 = { style: {"color":"#FFA600","top":"36vh","font-size":"13px"} }
const _hoisted_14 = { class: "card-top" }
const _hoisted_15 = { class: "card-top-right" }
const _hoisted_16 = { class: "bar" }
const _hoisted_17 = {
  class: "card-top-bottom-right",
  style: {"color":"#F8E400"}
}
const _hoisted_18 = { class: "card-top" }
const _hoisted_19 = { class: "card-top-right" }
const _hoisted_20 = { class: "bar" }
const _hoisted_21 = {
  class: "card-top-bottom-right",
  style: {"color":"#F8E400"}
}
const _hoisted_22 = { class: "card-top" }
const _hoisted_23 = { class: "card-top-right" }
const _hoisted_24 = { class: "bar" }
const _hoisted_25 = {
  class: "card-top-bottom-right",
  style: {"color":"#F8E400"}
}
const _hoisted_26 = { class: "tabs" }
const _hoisted_27 = { class: "bottom_text" }
const _hoisted_28 = ["innerHTML"]

import CustomHeader from '@/themes/themeTwo/components/common/customHeader.vue';
import VIPTableView from './components/vipTableView.vue';
import { computed, ref, watch } from 'vue';
import VipHistoryPopup from './components/vipHistoryPopup.vue';
import { VipData } from '@/view/vip/supportScript';
import { TAB_LIST } from '@/view/vip/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'vipView',
  props: {
    dataSet: {}
  },
  emits: ['vIPClaim', 'update:active'],
  setup(__props: any, { emit: __emit }) {

const progressPercentage = computed(() => 6500 * 100 / 10000);
const active = ref(0);
const historyRef = ref()
const vipConfigData = ref()
const tabList = computed(() => {
    return TAB_LIST
});
const showHistory = () => {
    historyRef.value.open()
}
const props = __props
const emit = __emit

const VIPClaim = () => {
    emit('vIPClaim')
}
watch(active, (val) => {
    emit('update:active', val)
})



return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('vip.title')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.dataSet.bannerIcon,
          alt: ""
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.dataSet.currentLevel), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_row, { class: "toData" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "15",
                class: "leftDetails"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('vip.receiveBonuses')), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.dataSet.remainRewards), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "9",
                style: {"display":"flex","align-items":"flex-start","margin-bottom":"15px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["claimBtn", _ctx.dataSet.remainRewards == 0 ? 'disableBtn' : '']),
                    onClick: VIPClaim
                  }, _toDisplayString(_ctx.$t('activity.reciev')), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "24" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_row, {
                    class: "bottomData",
                    onClick: showHistory
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "23",
                        class: "leftDetails"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('activity.bonuRegistation')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "1",
                        style: {"color":"#FFEE00","font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_icon, { name: "play" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_van_row, { style: {"padding":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "16",
                style: {"display":"flex","align-items":"end"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('vip.bettingValue')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "8",
                class: "card-top-right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.dataSet.VIPRewardsInfo?.betTotal), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "24" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: "progress",
                      style: _normalizeStyle({ width: _ctx.dataSet.VIPRewardsInfo?.betTotal / _ctx.dataSet.nextLevelRecord?.bet_min < 1 ? _ctx.dataSet.VIPRewardsInfo?.betTotal * 100 / _ctx.dataSet.nextLevelRecord.bet_min + '%' : '100%' })
                    }, null, 4),
                    _createElementVNode("div", {
                      class: "progress-end-dot",
                      style: _normalizeStyle({ left: `calc(${_ctx.dataSet.VIPRewardsInfo?.betTotal * 100 / _ctx.dataSet.nextLevelRecord?.bet_min}% - 6px)` })
                    }, null, 4)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "16" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("span", {
                    class: "card-top-bottom",
                    style: {"top":"36vh","font-size":"13px","color":"#FFA600"}
                  }, _toDisplayString(0), -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "8",
                class: "card-top-bottom-right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.dataSet.nextLevelRecord?.bet_min) + "(" + _toDisplayString(_ctx.$t('vip.title')) + " " + _toDisplayString(_ctx.dataSet.nextLevel) + ")", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (vipConfigData.value?.rewardsStatus?.isDailyReward === 1)
            ? (_openBlock(), _createBlock(_component_van_row, {
                key: 0,
                class: "bettingVolume"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "16",
                    style: {"display":"flex","align-items":"end"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('vip.dayBetVolume')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "card-top-right"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.dataSet.VIPRewardsInfo?.dailyTotalBet), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "24" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", {
                          class: "progress",
                          style: _normalizeStyle({ width: _ctx.dataSet.VIPRewardsInfo?.dailyTotalBet / _ctx.dataSet.nextLevelRecord?.daily_reward_retention < 1 ? _ctx.dataSet.VIPRewardsInfo?.dailyTotalBet * 100 / _ctx.dataSet.nextLevelRecord?.daily_reward_retention + '%' : '100%', background: '#ffba00' })
                        }, null, 4),
                        _createElementVNode("div", {
                          class: "progress-end-dot",
                          style: _normalizeStyle({ left: `calc(${_ctx.dataSet.VIPRewardsInfo?.dailyTotalBet * 100 / _ctx.dataSet.nextLevelRecord?.daily_reward_retention}% - 6px)` })
                        }, null, 4)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "8" }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("span", { class: "card-top-bottom" }, "0", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "16",
                    class: "card-top-bottom-right"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('vip.division')) + ": " + _toDisplayString(_ctx.dataSet.nextLevelRecord?.daily_reward_retention), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (vipConfigData.value?.rewardsStatus?.isWeeklyRewards === 1)
            ? (_openBlock(), _createBlock(_component_van_row, {
                key: 1,
                class: "bettingVolume"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "16",
                    style: {"display":"flex","align-items":"end"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('vip.weekBetVolume')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "card-top-right"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.dataSet.VIPRewardsInfo?.weeklyTotalBet), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "24" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", {
                          class: "progress",
                          style: _normalizeStyle({ width: _ctx.dataSet.VIPRewardsInfo?.weeklyTotalBet / _ctx.dataSet.nextLevelRecord?.week_reward_retention < 1 ? _ctx.dataSet.VIPRewardsInfo?.weeklyTotalBet * 100 / _ctx.dataSet.nextLevelRecord?.week_reward_retention + '%' : '100%', background: '#ffba00' })
                        }, null, 4),
                        _createElementVNode("div", {
                          class: "progress-end-dot",
                          style: _normalizeStyle({ left: `calc(${_ctx.dataSet.VIPRewardsInfo?.weeklyTotalBet * 100 / _ctx.dataSet.nextLevelRecord?.week_reward_retention}% - 6px)` })
                        }, null, 4)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "8" }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createElementVNode("span", { class: "card-top-bottom" }, _toDisplayString(0), -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "16",
                    class: "card-top-bottom-right"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('vip.division')) + ":" + _toDisplayString(_ctx.dataSet.nextLevelRecord?.week_reward_retention), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (vipConfigData.value?.rewardsStatus?.isMonthlyRewards === 1)
            ? (_openBlock(), _createBlock(_component_van_row, {
                key: 2,
                class: "bettingVolume"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "16",
                    style: {"display":"flex","align-items":"end"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('vip.monthBetVolume')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "8",
                    class: "card-top-right"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.dataSet.VIPRewardsInfo?.monthlyTotalBet), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "24" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", {
                          class: "progress",
                          style: _normalizeStyle({ width: _ctx.dataSet.VIPRewardsInfo?.monthlyTotalBet / _ctx.dataSet.nextLevelRecord?.month_reward_retention < 1 ? _ctx.dataSet.VIPRewardsInfo?.monthlyTotalBet * 100 / _ctx.dataSet.nextLevelRecord?.month_reward_retention + '%' : '100%', background: '#ffba00' })
                        }, null, 4),
                        _createElementVNode("div", {
                          class: "progress-end-dot",
                          style: _normalizeStyle({ left: `calc(${_ctx.dataSet.VIPRewardsInfo?.monthlyTotalBet * 100 / _ctx.dataSet.nextLevelRecord?.month_reward_retention}% - 6px)` })
                        }, null, 4)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "8" }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("span", { class: "card-top-bottom" }, _toDisplayString(0), -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "16",
                    class: "card-top-bottom-right"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('vip.division')) + ": " + _toDisplayString(_ctx.dataSet.nextLevelRecord?.month_reward_retention), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_van_tabs, {
            id: "vipTabs",
            active: active.value,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (index) => {
                return (_openBlock(), _createBlock(_component_van_tab, {
                  title: _ctx.$t(index.name),
                  key: index.id
                }, null, 8, ["title"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["active"])
        ]),
        _createVNode(VIPTableView, {
          activeNo: _ctx.dataSet.active,
          tableData: _ctx.dataSet.tabelData,
          activeData: _ctx.dataSet.vipConfigData?.rewardsStatus
        }, null, 8, ["activeNo", "tableData", "activeData"]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "12" })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activity_intro, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index,
              innerHTML: item
            }, null, 8, _hoisted_28))
          }), 128))
        ])
      ])
    ]),
    _createVNode(VipHistoryPopup, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512)
  ], 64))
}
}

})